module.exports = __webpack_public_path__ + "img/call.53be08b5.svg";